export default __webpack_public_path__ + "favicons/fav-prod-16.png";